"use client";

import { createContext, useContext, useState, type ReactNode } from 'react';

interface NavigationReadyContextType {
  isNavigationReady: boolean;
  setNavigationReady: (ready: boolean) => void;
}

const NavigationReadyContext = createContext<NavigationReadyContextType | undefined>(undefined);

export function NavigationReadyProvider({ children }: { children: ReactNode }) {
  const [isNavigationReady, setIsNavigationReady] = useState(false);

  return (
    <NavigationReadyContext.Provider value={{ 
      isNavigationReady, 
      setNavigationReady: setIsNavigationReady 
    }}>
      {children}
    </NavigationReadyContext.Provider>
  );
}

export function useNavigationReady() {
  const context = useContext(NavigationReadyContext);
  if (context === undefined) {
    throw new Error('useNavigationReady must be used within a NavigationReadyProvider');
  }
  return context;
}












